import { useMonkeysLocale } from '../../provider/context';

const messages = {
  "operationFailed": { "en": "The file operation failed. Review the input and try again.", "zh": "文件操作失败，请检查输入后重试。" },
  "apply": {
    "en": "Apply",
    "zh": "应用"
  },
  "cancel": {
    "en": "Cancel",
    "zh": "取消"
  },
  "compact": {
    "en": "Compact",
    "zh": "紧凑"
  },
  "confirm": {
    "en": "Confirm",
    "zh": "确认"
  },
  "confirmAction": {
    "en": "Confirm file action",
    "zh": "确认文件操作"
  },
  "create": {
    "en": "Create",
    "zh": "新建"
  },
  "delete": {
    "en": "Delete",
    "zh": "删除"
  },
  "detailed": {
    "en": "Detailed",
    "zh": "详细"
  },
  "diff": {
    "en": "Diff",
    "zh": "差异"
  },
  "directory": {
    "en": "Directory",
    "zh": "文件夹"
  },
  "discardReload": {
    "en": "Discard draft and reload",
    "zh": "放弃修改并重新加载"
  },
  "download": {
    "en": "Download",
    "zh": "下载"
  },
  "file": {
    "en": "File",
    "zh": "文件"
  },
  "actions": {
    "en": "File actions",
    "zh": "文件操作"
  },
  "files": {
    "en": "Files",
    "zh": "文件"
  },
  "kind": {
    "en": "Kind",
    "zh": "类型"
  },
  "loadingDiff": {
    "en": "Loading diff",
    "zh": "正在加载差异"
  },
  "path": {
    "en": "Path",
    "zh": "路径"
  },
  "refresh": {
    "en": "Refresh",
    "zh": "刷新"
  },
  "rename": {
    "en": "Rename",
    "zh": "重命名"
  },
  "save": {
    "en": "Save",
    "zh": "保存"
  },
  "search": {
    "en": "Search",
    "zh": "搜索"
  },
  "searchFiles": {
    "en": "Search files",
    "zh": "搜索文件"
  },
  "simple": {
    "en": "Simple",
    "zh": "简洁"
  },
  "sourceControl": {
    "en": "Source control",
    "zh": "源代码管理"
  },
  "viewMode": {
    "en": "View mode",
    "zh": "显示方式"
  },
  "binaryUnavailable": {
    "en": "Binary file cannot be previewed.",
    "zh": "无法预览二进制文件。"
  },
  "diffTooLarge": {
    "en": "Diff exceeds text editor limit.",
    "zh": "差异内容超过编辑器大小限制。"
  },
  "diffUnavailable": {
    "en": "Diff is unavailable.",
    "zh": "暂时无法查看差异。"
  },
  "changedExternally": {
    "en": "File changed externally; your draft is preserved.",
    "zh": "文件已被外部修改；你的草稿已保留。"
  },
  "tooLarge": {
    "en": "File exceeds text editor limit.",
    "zh": "文件超过编辑器大小限制。"
  },
  "imageUnavailable": {
    "en": "Image preview is unavailable.",
    "zh": "暂时无法预览图片。"
  },
  "tooManyExpanded": {
    "en": "Too many expanded paths.",
    "zh": "展开的路径数量过多。"
  },
  "deleteConfirm": {
    "en": "Delete the selected item?",
    "zh": "删除所选项目？"
  },
  "discardConfirm": {
    "en": "Discard unsaved changes?",
    "zh": "放弃未保存的修改？"
  },
  "name": {
    "en": "Name",
    "zh": "名称"
  },
  "size": {
    "en": "Size",
    "zh": "大小"
  },
  "modified": {
    "en": "Modified",
    "zh": "修改时间"
  },
  "permissions": {
    "en": "Permissions",
    "zh": "权限"
  },
  "type": {
    "en": "Type",
    "zh": "类型"
  },
  "empty": {
    "en": "Select a file to view or edit its contents.",
    "zh": "选择文件以查看或编辑内容。"
  },
  "emptyTree": {
    "en": "No matching files.",
    "zh": "没有匹配的文件。"
  },
  "renameItem": {
    "en": "Rename {name}",
    "zh": "重命名 {name}"
  },
  "deleteItem": {
    "en": "Delete {name}",
    "zh": "删除 {name}"
  },
  "downloadItem": {
    "en": "Download {name}",
    "zh": "下载 {name}"
  }
} as const;
export type RuntimeFileCopyKey = keyof typeof messages;
export function useRuntimeFileCopy(translate?: (key: string) => string) {
  const { locale } = useMonkeysLocale();
  return (name: RuntimeFileCopyKey, values?: Readonly<Record<string, string>>) => {
    const key = `monkeys.design.runtimeFiles.${name}`;
    const translated = translate?.(key);
    const template = translated && translated !== key ? translated : messages[name][locale.toLowerCase().startsWith('zh') ? 'zh' : 'en'];
    return template.replace(/\{([A-Za-z]+)\}/g, (placeholder, variable: string) => values?.[variable] ?? placeholder);
  };
}
